import Model from './Model'

export default class Type extends Model {
  resource () { return 'types' }
}
